export const MIN_PROGRAM_LENGTH_MS = 10 * 60000 // 10 minutes in MS
